<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="horario-diario" titulo="Horario / Diario" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate>
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!cargando" class="icon is-medium">
                      <i class="icon-clock4"></i>
                    </span>
                    <span *ngIf="cargando" class="icon is-medium">
                      <i class="icon-worldwide fa-spin"></i>
                    </span>
                    <span class="icon is-medium">
                      <i class="fa icon-edit-1"></i>
                    </span> Horarios Diarios
                  </p>
                </div>

              </div>

              <!-- Right side -->
              <div class="level-right">
                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x">
                    <i class="icon-back"> </i>
                  </span>
                  <span class="tooltiptext">Regresar</span>
                </a>


                <a class="navbar-item tooltip" (click)="generarPDF()">
                  <span class="icon fa-2x">
                    <i class="icon-printer2"></i>
                  </span>
                  <span class="tooltiptext">Imprimir</span>
                </a>
              </div>
            </nav>

          </div>
        </section>

        <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo'); ctrl.cargarCatalogo('dia_semana', 'dia-semana', 'diaSemana'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>

          <a id="imprimir_local" (click)="generarPDF(); "></a>
          <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
          <a id="diaSemana" (click)="asignarDiaSemana(ctrl.dia_semana); "></a>
          <div class="columns">
            <div class="column is-2">
              <label class="label">Período activos:</label>
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info text-success">
                  <input name="activos" id="activos" [(ngModel)]="activos" (change)="seleccionarActivos($event, ctrl.dia_semana)" class="styled" type="checkbox" [checked]="activos">
                  <label for="activos">
                    Todos
                  </label>
                </div>
              </div>
            </div>
            <div class="column is-5">
              <label class="label">Período escolar:</label>
              <div class="control has-icons-left has-icons-right">
                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>

                <ng-select2 [disabled]="activos ? true : ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarPeriodo($event, ctrl.periodos_escolares);" [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>

            <div class="column is-5">
              <label class="label">Seleccione el día:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="dias_disponibles ? dias_disponibles.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarDia($event);"
                [data]="dias_disponibles"></ng-select2>
              </div>
            </div>
          </div>

          <div *ngIf="horario_cargado" class="content" id="contenido_horario" style="max-width: 81vw;overflow-y: auto;">

            <div *ngFor="let modalidad of ph_modalidades" >
              <div class="box">
                <article class="media">
                  <div class="media-left">
                    <figure class="image is-64x64">
                      <img src="{{API_PATH}}/adjunto/configuracion/{{configuracion.sucursal.logo != '' ? configuracion.sucursal.logo : configuracion.empresa.logo}}" style="width: 64px;">
                    </figure>
                  </div>
                  <div class="media-content">
                    <div class="content" align="center" style="font-weight: bold">
                      <h2>{{configuracion.empresa.nombre}}</h2>
                      <h3>{{configuracion.empresa.subnombre}}</h3>
                      <h4>CAMPUS: {{configuracion.sucursal.nombre}}</h4>

                      <strong>DÍA: {{dia_semana.text}}</strong>

                    </div>
                  </div>
                </article>
              </div>

              <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tabla_horario">
                <thead>
                  <tr>
                    <th *ngFor="let modulo of ph_modulos[modalidad];"><div align="center">{{modulo}}</div></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td *ngFor="let modulo of ph_modulos[modalidad];" [style.width.%]="100/ph_modulos[modalidad].length">
                      <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" style="font-size: medium;">
                        <tbody>
                          <tr *ngFor="let hora of ph_horas[modalidad]">
                            <td>
                              <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                <thead>
                                  <tr>
                                    <th colspan="3" width="10%">
                                      <div align="center">{{hora}}</div>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th >Grupo</th>
                                    <th>Materia</th>
                                    <th>Docente</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let dia of horario_diario[modalidad][modulo][hora];">
                                    <td>{{dia.grupos.clave}} {{dia.grupos.nivel}} {{dia.grupos.identificador}} / {{dia.grupos.carreras_planes.carreras.nombre}} - {{dia.grupos.carreras_planes.planes_estudios.nombre}}</td>
                                    <td>{{dia.materias.nombre}}</td>
                                    <td>{{dia.docente.nombre}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>


          </div>
        </section>
      </form>
    </div>
  </div>
</div>
